/**
 * Header.jsx
 * Created by michaelbray on 6/16/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import Subheader from './Subheader';

const propTypes = {
    title: PropTypes.string,
    headerClass: PropTypes.string,
    subheaderItems: PropTypes.array
};

const defaultProps = {
    title: "RECREATION.GOV STYLE GUIDE",
    headerClass: "header-primary",
    subheaderItems: []
};

export default class Header extends React.Component {
    render() {
        let subheader = null;
        if (this.props.subheaderItems.length > 0) {
            subheader = <Subheader {...this.props} />;
        }

        return (
            <div>
                <section
                    className={`header-container ${this.props.headerClass}`}>
                    <div className="header">
                        <div className="header-left">
                            <h1 className="header-logo">
                                <Link to="/">{this.props.title}</Link>
                            </h1>
                        </div>
                    </div>
                </section>
                {subheader}
            </div>
        );
    }
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
